import * as Linking from "expo-linking";

export class RealBackend {

    constructor(apiEndpoint) {
        this.apiEndpoint = apiEndpoint
    }

    async retrieveMe(authToken) {
        return await (await fetch(`${this.apiEndpoint}/me`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

    async updateMe(authToken, data) {
        return await (await fetch(`${this.apiEndpoint}/me`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

    async syncPushToken(authToken, token) {
        return await (await fetch(`${this.apiEndpoint}/me/sync_push_token`, {
            method: 'POST',
            body: JSON.stringify({
                token
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

    async subscribe(authToken) {
        return await (await fetch(`${this.apiEndpoint}/subscription?redirect_to=${Linking.makeUrl()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

    async pickupRequest(authToken) {
        return await (await fetch(`${this.apiEndpoint}/pickup_requests`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

    async additionalBin(authToken) {
        return await (await fetch(`${this.apiEndpoint}/additional_bin?redirect_to=${Linking.makeUrl()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

    async cancelPickupRequest(authToken, id) {
        return await (await fetch(`${this.apiEndpoint}/pickup_requests/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

    async completeTransaction(authToken, transaction_id) {
        return await (await fetch(`${this.apiEndpoint}/mcb_payment_gateway`, {
            method: 'POST',
            body: JSON.stringify({
                transaction_id
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authToken
            }
        })).json()
    }

}